/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { SagaIterator } from 'redux-saga';
import { call, fork, put, select } from 'redux-saga/effects';
import {
  OptionUtils,
  Ducks,
  PurchaseOption,
  FileFormat,
  ActionsEventActionNames,
  PurchaseOptionType,
  ProductPrice,
  ProductPriceStatus,
} from '@wit/vtv-x-foundation-lib';
import { ActionCreators as EntitlementActionCreators } from 'core/store/ducks/entitlements/index';
import { addRentActionEvent } from '../../analytics/actionsEvent';
import * as Data from '../data';
import * as Context from '../context';

function* markVodAsPurchased(productPrice: ProductPrice, ctx: Context.PiContext): SagaIterator<void> {
  const currentVodPrices: ProductPrice[] = yield select(Data.Selectors.vodPrices, ctx);
  const vodPrices: ProductPrice[] = currentVodPrices.map((price) => {
    if (price.fileId === productPrice.fileId && price.ppvModuleId === productPrice.ppvModuleId) {
      return { ...price, status: ProductPriceStatus.PURCHASED };
    }
    return price;
  });
  yield put(Data.ActionCreators.update({ context: ctx, data: { vodPrices } }));
}

export default function* run(option: PurchaseOption, ctx: Context.PiContext): SagaIterator {
  if (OptionUtils.isPurchaseOption(option)) {
    const { productPrice, ppvModule } = option;
    const error = yield call(Ducks.Transactions.purchase, ppvModule.id, productPrice);
    if (!error) {
      yield call(markVodAsPurchased, productPrice, ctx);
      yield put(EntitlementActionCreators.refresh());
    }
    yield fork(
      addRentActionEvent,
      option.format === FileFormat.MAIN_HD || option.format === FileFormat.MAIN_UHD
        ? ActionsEventActionNames.RENT_HD
        : ActionsEventActionNames.RENT_SD,
      option.asset,
      option.productPrice,
      option.purchaseOptionType === PurchaseOptionType.BUY,
      error
    );
    if (error) {
      throw error;
    }
  }
}
